import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({
  children
}) => {
  return <div className="flex flex-col min-h-screen bg-wheat-gold/10" data-id="element-358">
      <Header data-id="element-359" />
      <main className="flex-grow" data-id="element-360">{children}</main>
      <Footer data-id="element-361" />
    </div>;
};